export default "__VITE_ASSET__uQkwZ3DP__"